import { AgentSettingsDTO, PlayerDTO } from '@envclient/envcore';
import { Agent } from './Agent';
import { Property, Type } from '@dipscope/type-manager';
import 'reflect-metadata';

export enum Color {
  BLUE,
  RED,
  YELLOW,
  ORANGE,
  GREY
}

@Type({
  injectable: true,
  discriminant: 'Player'
})
class Player {
  @Property()
  id: number;
  @Property()
  displayName: string;
  @Property(Number)
  color: Color;
  @Property()
  score: number = 0;
  @Property()
  inactiveCount: number = 0;
  // per-player bot-agent config, set by the seat's bot user via the Agent Settings modal (opt-in).
  @Property()
  agentSettings?: AgentSettingsDTO;

  reconnectTimeout: NodeJS.Timeout;

  agent: Agent;

  addScore(inc: number) {
    this.score += inc;
  }

  //private agent:Agent;

  toDTO(): PlayerDTO {
    return {
      id: this.id,
      displayName: this.displayName,
      color: this.color,
      score: this.score,
      inactiveCount: this.inactiveCount,
      agentSettings: this.agentSettings
    };
  }
}

export default Player;
